import { useRadioGroupState } from "@react-stately/radio";
import { useProviderProps } from "@react-spectrum/provider";
import { useFormProps } from "@react-spectrum/form";
import { Label } from "@react-spectrum/label";
import { useRadio, useRadioGroup } from "@react-aria/radio";
import { useHover } from "@react-aria/interactions";
import _react, { forwardRef, useRef, useContext } from "react";
import { FocusRing } from "@react-aria/focus";
import { classNames, useFocusableRef, useStyleProps, useDOMRef } from "@react-spectrum/utils";
import _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import "./main.css";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/radio/vars.css
var $caf9effdead839c12d96b05817b87a$exports = {};
$caf9effdead839c12d96b05817b87a$exports = {
  "spectrum-Radio": "_spectrum-Radio_db05c",
  "spectrum-Radio-input": "_spectrum-Radio-input_db05c",
  "spectrum-Radio-button": "_spectrum-Radio-button_db05c",
  "focus-ring": "_focus-ring_db05c",
  "spectrum-Radio-label": "_spectrum-Radio-label_db05c",
  "spectrum-Radio--labelBelow": "_spectrum-Radio--labelBelow_db05c",
  "is-hovered": "_is-hovered_db05c",
  "spectrum-Radio--quiet": "_spectrum-Radio--quiet_db05c",
  "is-invalid": "_is-invalid_db05c"
};

const $ab95946e1e830e3cfac331e9d67ee25$export$RadioContext = _react.createContext(null);

function $ab95946e1e830e3cfac331e9d67ee25$export$useRadioProvider() {
  return useContext($ab95946e1e830e3cfac331e9d67ee25$export$RadioContext);
}

var $caf9effdead839c12d96b05817b87a$$interop$default = $parcel$interopDefault($caf9effdead839c12d96b05817b87a$exports);

function $b8ae36aee0da7b42a78337dae86364$var$Radio(props, ref) {
  let {
    isDisabled,
    children,
    autoFocus
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["isDisabled", "children", "autoFocus"]);

  let {
    styleProps
  } = useStyleProps(otherProps);
  let {
    hoverProps,
    isHovered
  } = useHover({
    isDisabled
  });
  let inputRef = useRef(null);
  let domRef = useFocusableRef(ref, inputRef);
  let radioGroupProps = $ab95946e1e830e3cfac331e9d67ee25$export$useRadioProvider();
  let {
    isEmphasized,
    validationState,
    state
  } = radioGroupProps;
  let {
    inputProps
  } = useRadio(_babelRuntimeHelpersEsmExtends({}, props, radioGroupProps, {
    isDisabled
  }), state, inputRef);
  return /*#__PURE__*/_react.createElement("label", _babelRuntimeHelpersEsmExtends({}, styleProps, hoverProps, {
    ref: domRef,
    className: classNames($caf9effdead839c12d96b05817b87a$$interop$default, 'spectrum-Radio', {
      // Removing. Pending design feedback.
      // 'spectrum-Radio--labelBelow': labelPosition === 'bottom',
      'spectrum-Radio--quiet': !isEmphasized,
      'is-disabled': isDisabled,
      'is-invalid': validationState === 'invalid',
      'is-hovered': isHovered
    }, styleProps.className)
  }), /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($caf9effdead839c12d96b05817b87a$$interop$default, 'focus-ring'),
    autoFocus: autoFocus
  }, /*#__PURE__*/_react.createElement("input", _babelRuntimeHelpersEsmExtends({}, inputProps, {
    ref: inputRef,
    className: classNames($caf9effdead839c12d96b05817b87a$$interop$default, 'spectrum-Radio-input')
  }))), /*#__PURE__*/_react.createElement("span", {
    className: classNames($caf9effdead839c12d96b05817b87a$$interop$default, 'spectrum-Radio-button')
  }), children && /*#__PURE__*/_react.createElement("span", {
    className: classNames($caf9effdead839c12d96b05817b87a$$interop$default, 'spectrum-Radio-label')
  }, children));
}
/**
 * Radio buttons allow users to select a single option from a list of mutually exclusive options.
 * All possible options are exposed up front for users to compare.
 */


export const Radio = forwardRef($b8ae36aee0da7b42a78337dae86364$var$Radio);
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/fieldlabel/vars.css
var $c9fb1f4220ea2c59cb2e10f0e9828c6e$exports = {};
$c9fb1f4220ea2c59cb2e10f0e9828c6e$exports = {
  "spectrum-FieldLabel": "_spectrum-FieldLabel_36b9b",
  "spectrum-FieldLabel--positionSide": "_spectrum-FieldLabel--positionSide_36b9b",
  "spectrum-FieldLabel-requiredIcon": "_spectrum-FieldLabel-requiredIcon_36b9b",
  "spectrum-FieldLabel--alignEnd": "_spectrum-FieldLabel--alignEnd_36b9b",
  "spectrum-Field": "_spectrum-Field_36b9b",
  "spectrum-Field--positionTop": "_spectrum-Field--positionTop_36b9b",
  "spectrum-Field-field": "_spectrum-Field-field_36b9b",
  "spectrum-Field-field--multiline": "_spectrum-Field-field--multiline_36b9b",
  "spectrum-Field--positionSide": "_spectrum-Field--positionSide_36b9b",
  "spectrum-Form": "_spectrum-Form_36b9b",
  "spectrum-Form--positionSide": "_spectrum-Form--positionSide_36b9b",
  "spectrum-Form--positionTop": "_spectrum-Form--positionTop_36b9b",
  "spectrum-Form-itemLabel": "_spectrum-Form-itemLabel_36b9b",
  "is-disabled": "_is-disabled_36b9b"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/fieldgroup/vars.css
var $d9233c793c189283ec9d2429b27b9$exports = {};
$d9233c793c189283ec9d2429b27b9$exports = {
  "spectrum-FieldGroup": "_spectrum-FieldGroup_8cb9b",
  "spectrum-FieldGroup--positionSide": "_spectrum-FieldGroup--positionSide_8cb9b",
  "spectrum-FieldGroup-group": "_spectrum-FieldGroup-group_8cb9b",
  "spectrum-FieldGroup-group--horizontal": "_spectrum-FieldGroup-group--horizontal_8cb9b"
};
var $d9233c793c189283ec9d2429b27b9$$interop$default = $parcel$interopDefault($d9233c793c189283ec9d2429b27b9$exports);
var $c9fb1f4220ea2c59cb2e10f0e9828c6e$$interop$default = $parcel$interopDefault($c9fb1f4220ea2c59cb2e10f0e9828c6e$exports);

function $cc551574103dc5b9b788866e53c$var$RadioGroup(props, ref) {
  props = useProviderProps(props);
  props = useFormProps(props);

  let {
    isEmphasized,
    isRequired,
    necessityIndicator,
    label,
    labelPosition = 'top',
    labelAlign,
    validationState,
    children,
    orientation = 'vertical'
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["isEmphasized", "isRequired", "necessityIndicator", "label", "labelPosition", "labelAlign", "validationState", "children", "orientation"]);

  let domRef = useDOMRef(ref);
  let {
    styleProps
  } = useStyleProps(otherProps);
  let state = useRadioGroupState(props);
  let {
    radioGroupProps,
    labelProps
  } = useRadioGroup(props, state);
  return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, styleProps, radioGroupProps, {
    className: classNames($d9233c793c189283ec9d2429b27b9$$interop$default, 'spectrum-FieldGroup', {
      'spectrum-FieldGroup--positionSide': labelPosition === 'side'
    }, // This is so radio works inside a <Form>
    classNames($c9fb1f4220ea2c59cb2e10f0e9828c6e$$interop$default, 'spectrum-Field'), styleProps.className),
    ref: domRef
  }), label && /*#__PURE__*/_react.createElement(Label, _babelRuntimeHelpersEsmExtends({}, labelProps, {
    elementType: "span",
    labelPosition: labelPosition,
    labelAlign: labelAlign,
    isRequired: isRequired,
    necessityIndicator: necessityIndicator
  }), label), /*#__PURE__*/_react.createElement("div", {
    className: classNames($d9233c793c189283ec9d2429b27b9$$interop$default, 'spectrum-FieldGroup-group', {
      'spectrum-FieldGroup-group--horizontal': orientation === 'horizontal'
    })
  }, /*#__PURE__*/_react.createElement($ab95946e1e830e3cfac331e9d67ee25$export$RadioContext.Provider, {
    value: {
      isEmphasized,
      isRequired,
      validationState,
      state
    }
  }, children)));
}
/**
 * Radio groups allow users to select a single option from a list of mutually exclusive options.
 * All possible options are exposed up front for users to compare.
 */


export const RadioGroup = _react.forwardRef($cc551574103dc5b9b788866e53c$var$RadioGroup);
//# sourceMappingURL=module.js.map
